




























import AppVue from "@/AppVue.vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Question } from "../core/models/question.model";
import MultiLineString from "./MultiLineString.vue";

@Component({
  components: {
    MultiLineString,
  },
})
export default class PreambleCard extends AppVue {
  @Prop() currentNode: Question;
  @Prop({ default: true }) autoScroll: boolean;
  @Prop() language: string;
}
